import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "admin-main-content" }
const _hoisted_2 = { class: "admin-content-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, " 상품 목록 ", -1)
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header justify-content-between\"><h3 class=\"card-title\">상품 목록</h3><div class=\"card-tools\"><div class=\"input-group input-group-sm\" style=\"width:150px;\"><input type=\"text\" name=\"table_search\" class=\"form-control float-right\" placeholder=\"Search\"><div class=\"input-group-append\"><button type=\"submit\" class=\"btn btn-default\"><i class=\"fas fa-search\"></i></button></div></div></div></div>", 1)
const _hoisted_7 = { class: "card-body table-responsive p-0" }
const _hoisted_8 = { class: "table table-hover text-nowrap" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "카테고리"),
    /*#__PURE__*/_createVNode("th", null, "셀러"),
    /*#__PURE__*/_createVNode("th", null, "제품명"),
    /*#__PURE__*/_createVNode("th", null, "판매가격"),
    /*#__PURE__*/_createVNode("th", null, "공급가격"),
    /*#__PURE__*/_createVNode("th", null, "마진율"),
    /*#__PURE__*/_createVNode("th", null, "판매상태"),
    /*#__PURE__*/_createVNode("th", null, "추천상품"),
    /*#__PURE__*/_createVNode("th", null, "인기상품"),
    /*#__PURE__*/_createVNode("th", null, "바로가기")
  ])
], -1)
const _hoisted_10 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_12 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_14 = { class: "pagination-wrapper" }
const _hoisted_15 = { class: "pagination justify-content-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "page-link",
    href: "#",
    tabindex: "-1"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "이전")
  ])
], -1)
const _hoisted_17 = {
  class: "page-link",
  href: "#"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "page-link",
    href: "#"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "다음")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", null, [
        _createVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goResgiter && _ctx.goResgiter(...args)))
        }, "등록")
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("table", _hoisted_8, [
            _hoisted_9,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productList, (product) => {
                return (_openBlock(), _createBlock("tr", {
                  key: product.id
                }, [
                  _createVNode("td", null, _toDisplayString(product.category_name), 1),
                  _createVNode("td", null, _toDisplayString(product.seller_name), 1),
                  _createVNode("td", null, _toDisplayString(product.name), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.getCurruncy(product.price_sale)) + "원", 1),
                  _createVNode("td", null, _toDisplayString(_ctx.getCurruncy(product.price_usin)) + "원", 1),
                  _createVNode("td", null, _toDisplayString((
                      (1 - product.price_usin / product.price_sale) *
                      100
                    ).toFixed(2)) + "% ", 1),
                  _createVNode("td", null, _toDisplayString(product.sale_state_name), 1),
                  _createVNode("td", null, [
                    _createVNode("label", _hoisted_10, [
                      _withDirectives(_createVNode("input", {
                        onChange: ($event: any) => (
                        _ctx.checkRecommend(product.data_cd, product.name, $event)
                      ),
                        type: "checkbox",
                        class: "c-switch-input",
                        "onUpdate:modelValue": ($event: any) => (product.is_recommend = $event)
                      }, null, 40, ["onChange", "onUpdate:modelValue"]), [
                        [_vModelCheckbox, product.is_recommend]
                      ]),
                      _hoisted_11
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode("label", _hoisted_12, [
                      _withDirectives(_createVNode("input", {
                        onChange: ($event: any) => (
                        _ctx.checkPopular(product.data_cd, product.name, $event)
                      ),
                        type: "checkbox",
                        class: "c-switch-input",
                        "onUpdate:modelValue": ($event: any) => (product.is_popular = $event)
                      }, null, 40, ["onChange", "onUpdate:modelValue"]), [
                        [_vModelCheckbox, product.is_popular]
                      ]),
                      _hoisted_13
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode("button", {
                      class: "btn btn-primary",
                      onClick: ($event: any) => (_ctx.viewDetail(product.data_cd))
                    }, " 상세보기 ", 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createVNode("nav", _hoisted_14, [
            _createVNode("ul", _hoisted_15, [
              _hoisted_16,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.totalPage, (index) => {
                return (_openBlock(), _createBlock("li", {
                  class: "page-item",
                  key: index,
                  onClick: ($event: any) => (_ctx.loadPage(index - 1))
                }, [
                  _createVNode("a", _hoisted_17, _toDisplayString(index), 1)
                ], 8, ["onClick"]))
              }), 128)),
              _hoisted_18
            ])
          ])
        ])
      ])
    ])
  ]))
}